import React, { useState } from 'react'
import { login } from '../../service/apiService'
import {  useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { adminlog } from '../../features/auth'
const Login = () => {
  const [username,setUsername] = useState()
  const [password,setPassword] = useState()
 const navigate = useNavigate()
 const {adminlogedin} = useSelector((state) => state.auth)
 const dispatch = useDispatch()
  const handleSubmit = async (e) => {
    e.preventDefault()
    let params = {username,password}
    let res = await login(params)
    if(res?.data) localStorage.setItem('token', res?.data?.accessToken)
    if(res?.data){ 
      dispatch(adminlog(true));
      navigate('/home',{replace:true}) 
    } 
  }
  return (
    <>
    <section className="login" style={{height:'100vh'}}>
        <div className="container-fluid p-0 h-100">
          <div className="row g-0 h-100">
            <div className="col-lg-6 order-lg-2">
              <div className="sign-box">
                 <div className="vcenter">
                   <div className="mid">
                   <h1>SIGN IN</h1>
                 <p>Welcome to The Imperium . Please enter your login credentials below.</p>
                   <form>
                      <div className="mb-3">
                        <label for="exampleInputEmail1" className="form-label">Email</label>
                        <input type="email" value={username} onChange={(e) => setUsername(e.target.value)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                      </div>
                      <div className="mb-3">
                        <label for="exampleInputPassword1" className="form-label">Password</label>
                        <input type="password" onChange={(e) => setPassword(e.target.value)} className="form-control" id="exampleInputPassword1" />
                        <i className="toggle-password fa fa-fw fa-eye-slash"></i>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between">
                        <div className="mb-3 form-check">
                         <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                         <label className="form-check-label" for="exampleCheck1">Remember me</label>
                        </div> 
                        {/* <a href="forgot-password.html" className="forg">Forgot Password?</a> */}
                      </div>
                      <button href="index.html" onClick={handleSubmit} type="submit" className="btn">SIGN IN</button>
                    </form>
                 </div>
                 </div>
              </div>  
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <div className="vcenter">
                <div className="mid">
                 <img src={require('../../assets/images/logo-imox.png')} className="img-fluid m-auto d-block" /> 
                </div>    
              </div>  
            </div>
          </div>  
        </div>
        
      </section>
    </>
  )
}

export default Login

